export default {"src":"kbwebsite/assets/_next/static/media/marker-pin.e1b816ea.svg","height":24,"width":24};